import { ComponentPropsWithoutRef, FC } from "react";

type BadgeProps = {} & ComponentPropsWithoutRef<"div">;

const Badge: FC<BadgeProps> = ({ ...rest }) => {
  return (
    <div
      {...rest}
      className={`${rest.className} px-2 py-0.5 bg-white/20 backdrop-blur-sm rounded-full text-white flex items-center justify-center truncate`}
    >
      {rest.children}
    </div>
  );
};

export default Badge;
